/* unplugin-vue-components disabled */import { render } from "./projectdingdan.vue?vue&type=template&id=15793fd8"
import script from "./projectdingdan.vue?vue&type=script&lang=js"
export * from "./projectdingdan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__